import React, { useState, } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import toast from 'react-hot-toast';

//Serivce

//Redux
import Layout from '../../../Layout/Layout';
import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import { InputField } from '../../../Components/formElements/InputField';
//API
import plmItemService from "../../../services/plm_appCommonService";

const ArticleCreation = () => {
  localStorage.setItem('menu', '');
  localStorage.setItem('submenu', '-');
  const [errorMsg, /*setErrorMsg*/] = useState('');
  const [disabled, setDisabled] = useState(false);

  const [formInputs, setFormInputs] = useState({
    articleId: "",
    articleDescription: "",
    division: "",
    articleType: "",
    articleCategory: "",
    merchandiseCategory: "",
    characteristicProfile: "",
    baseUnitofMeasure: "",
    netWeight: "",
    grossWeight: "",
    weightUnit: "",
    commodityCode: "",
    style: "",
    fabricContentGroup: "",
    fabricContent: "",
    oldArticleNumber: "",
    externalMerchandiseCategory: "",
    brand: "",
    fiberCodeTextiles: "",
    percentageShareOfFiber: "",
    countryOfOriginOfArticle: "",
    futurePlannedPrice1: "",
    futurePlannedPriceIsValid: "",
    controlCodeForConsumptionTaxes: "",
    seasonCategory: "",
    seasonActiveInventoryManagementIndicator: "",
    segmentationStructure: "",
    segmentationStrategy: "",
    segmentationRelevant: "",
    articleConversionID: "",
    fashionGrade: "",
    seasonYear: "",
    season: "",
    fashionCollection: "",
    fashionTheme: "",
    seasonIndicator: "",
    storageSectID: "",
    stockPlacement: "",
    stockRemoval: "",
    gender: "",
    subGender: "",
    styleDescription: "",
    multipleMRP: "",
    fabricCode: "",
    fabricFinish: "",
    fabricType: "",
    weave: "",
    yarnType: "",
    leather: "",
    FIT: "",
    FITName: "",
    designCode: "",
    designType: "",
    collor_Neck_Pleate: "",
    sleev: "",
    occasion: "",
    garmentFinish: "",
    inseam: "",
    subLabel: "",
    categoryGroup: "",
    subCategory: "",
    categoryType: "",
    selable: "",
    returnable: "",
    class1: "",
    class2: "",
    class3: "",
    class4: "",
    freeTextBarcode1: "",
    freeTextBarcode2: "",
    freeTextBarcode3: "",
    WRAP_Count: "",
    WEFT_Count: "",
    endsPerInch: "",
    picksPerInch: "",
    TaxClassification: ""
  });
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs(formInputs => ({ ...formInputs, [name]: value }));
  };
  const handleSave = async () => {
    const obj = {
      data: formInputs,
    };
    const toastId = toast.loading('Loading...', {
      position: 'top-right',
    });
    setDisabled(true);
    await plmItemService.updateArticleDocument(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || 'added successfully', {
          duration: 2000,
          position: 'top-right',
        });
        // Update response value in Redux Store
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: 'top-right',
        });
      }
      setDisabled(false);
    });
    toast.dismiss(toastId);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className='justify-center subContent'>
        <Col xs={12} md={12} lg={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className='mainTitle'>Article Creation </h2>
            <p className='subText'>Article Creation.</p>
            <hr />
            <section className="section profile">
              <div className="row">
                <div className="col-xl-12">
                  {/* card 1 */}
                  <div className="card ">
                    <div className="card-body pt-3">
                      {/* nav link section */}
                      <ul className="nav nav-tabs nav-tabs-bordered">
                        <li className="nav-item">
                          <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#basicData">Basic Data</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#basicDataFashion">Basic Data: Fashion</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#dimension">Basic Data: Attribute</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#logisticsDc">Logistics: DC</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#logisticsDcFashion">Logistics: DC Fashion</button>
                        </li>
                        <li className="nav-item">
                          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#logisticsStore">Logistics: Store(Accounting)</button>
                        </li>
                      </ul>
                      {/* Basic Data */}
                      <div className="tab-content pt-2">
                        <div className="tab-pane fade show active profile-overview profile-edit" id="basicData">
                          {/* Over view */}
                          <div className="tab-pane fade show active profile-overview" id="basicData">
                            <form>
                              <Row className=''>
                                <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap '>
                                  <h5 className="card-title" style={{ color: '#012970' }}>General Data</h5>
                                  <hr />
                                  <div className="row mb-3">
                                    <label for="articleDescription" className="col-md-4 col-lg-3 col-form-label">Article Description</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="articleDescription" type="text" className="form-control" id="articleDescription" value={formInputs.articleDescription || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="division" className="col-md-4 col-lg-3 col-form-label">Division</label>
                                    <div className="col-md-2 col-lg-2 pe-2">
                                      <ComboboxField
                                        name="division1"
                                        type="text"
                                        className="form-control "
                                        value={formInputs.division || ""}
                                        onChange={onInputChange}
                                      />
                                    </div>
                                    <div className="col-md-6 col-lg-7">
                                      <InputField name="division" type="text" className="form-control" id="division" value={formInputs.division || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="articleType" className="col-md-4 col-lg-3 col-form-label">Article Type</label>
                                    <div className="col-md-2 col-lg-2 pe-2">
                                      <ComboboxField
                                        name="articleType"
                                        type="text"
                                        className="form-control "
                                        value={formInputs.articleType || ""}
                                        onChange={onInputChange}
                                      />
                                    </div>
                                    <div className="col-md-6 col-lg-7">
                                      <InputField name="articleType" type="text" className="form-control" id="articleType" value={formInputs.articleType || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="brand" className="col-md-4 col-lg-3 col-form-label">Brand</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="brand" type="text" className="form-control" id="brand" value={formInputs.brand || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="commodityCode" className="col-md-4 col-lg-3 col-form-label">Commodity Code</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="commodityCode" type="text" className="form-control" id="commodityCode" value={formInputs.commodityCode || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="oldArticleNumber" className="col-md-4 col-lg-3 col-form-label">Old Article Number</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="oldArticleNumber" type="text" className="form-control" id="oldArticleNumber" value={formInputs.oldArticleNumber || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="externalMerchandiseCategory" className="col-md-4 col-lg-3 col-form-label">External Merchandise Category</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="externalMerchandiseCategory" type="text" className="form-control" id="externalMerchandiseCategory" value={formInputs.externalMerchandiseCategory || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fiberCodeTextiles" className="col-md-4 col-lg-3 col-form-label">Fiber Code for Textiles (Component 1)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="fiberCodeTextiles" type="text" className="form-control" id="fiberCodeTextiles" value={formInputs.fiberCodeTextiles || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="percentageShareOfFiber" className="col-md-4 col-lg-3 col-form-label">Percentage Share of Fiber (Component 1)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="percentageShareOfFiber" type="text" className="form-control" id="percentageShareOfFiber" value={formInputs.percentageShareOfFiber || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fiberCodeTextiles" className="col-md-4 col-lg-3 col-form-label">Fiber Code for Textiles (Component 2)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="fiberCodeTextiles" type="text" className="form-control" id="fiberCodeTextiles" value={formInputs.fiberCodeTextiles || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="percentageShareOfFiber" className="col-md-4 col-lg-3 col-form-label">Percentage Share of Fiber (Component 2)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="percentageShareOfFiber" type="text" className="form-control" id="percentageShareOfFiber" value={formInputs.percentageShareOfFiber || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fiberCodeTextiles" className="col-md-4 col-lg-3 col-form-label">Fiber Code for Textiles (Component 3)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="fiberCodeTextiles" type="text" className="form-control" id="fiberCodeTextiles" value={formInputs.fiberCodeTextiles || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="percentageShareOfFiber" className="col-md-4 col-lg-3 col-form-label">Percentage Share of Fiber (Component 3)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="percentageShareOfFiber" type="text" className="form-control" id="percentageShareOfFiber" value={formInputs.percentageShareOfFiber || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fiberCodeTextiles" className="col-md-4 col-lg-3 col-form-label">Fiber Code for Textiles (Component 4)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="fiberCodeTextiles" type="text" className="form-control" id="fiberCodeTextiles" value={formInputs.fiberCodeTextiles || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="percentageShareOfFiber" className="col-md-4 col-lg-3 col-form-label">Percentage Share of Fiber (Component 4)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="percentageShareOfFiber" type="text" className="form-control" id="percentageShareOfFiber" value={formInputs.percentageShareOfFiber || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fiberCodeTextiles" className="col-md-4 col-lg-3 col-form-label">Fiber Code for Textiles (Component 5)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="fiberCodeTextiles" type="text" className="form-control" id="fiberCodeTextiles" value={formInputs.fiberCodeTextiles || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="percentageShareOfFiber" className="col-md-4 col-lg-3 col-form-label">Percentage Share of Fiber (Component 5)</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="percentageShareOfFiber" type="text" className="form-control" id="percentageShareOfFiber" value={formInputs.percentageShareOfFiber || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="countryOfOriginOfArticle" className="col-md-4 col-lg-3 col-form-label">Country of Origin of Article</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="countryOfOriginOfArticle" type="text" className="form-control" id="countryOfOriginOfArticle" value={formInputs.countryOfOriginOfArticle || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="fashionGrade" className="col-md-4 col-lg-3 col-form-label">Fashion Grade</label>
                                    <div className="col-md-8 col-lg-9">
                                      <InputField name="fashionGrade" type="text" className="form-control" id="fashionGrade" value={formInputs.fashionGrade || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap' >
                                  <h5 className="card-title" style={{ color: '#012970' }}> Article Group</h5>
                                  <hr />
                                  <div className="row mb-3">
                                    <label for="articleCategory" className="col-md-4 col-lg-3 col-form-label">Article Category</label>
                                    <div className="col-md-2 col-lg-2 pe-2">
                                      <ComboboxField
                                        name="articleCategory"
                                        type="text"
                                        className="form-control "
                                        value={formInputs.articleCategory || ""}
                                        onChange={onInputChange}
                                      />
                                    </div>
                                    <div className="col-md-6 col-lg-7">
                                      <InputField name="articleCategory" type="text" className="form-control" id="articleCategory" value={formInputs.articleCategory || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="merchandiseCategory" className="col-md-4 col-lg-3 col-form-label">Merchandise Category</label>
                                    <div className="col-md-2 col-lg-2 pe-2">
                                      <ComboboxField
                                        name="merchandiseCategory"
                                        type="text"
                                        className="form-control "
                                        value={formInputs.merchandiseCategory || ""}
                                        onChange={onInputChange}
                                      />
                                    </div>
                                    <div className="col-md-6 col-lg-7">
                                      <InputField name="merchandiseCategory" type="text" className="form-control" id="merchandiseCategory" value={formInputs.merchandiseCategory || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="externalMerchandiseCategory" className="col-md-4 col-lg-3 col-form-label">External Merchandise Category</label>
                                    <div className="col-md-8 col-lg-9">
                                      <input name="externalMerchandiseCategory" type="text" className="form-control" id="externalMerchandiseCategory" value={formInputs.externalMerchandiseCategory || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <div className="row mb-3">
                                    <label for="characteristicProfile" className="col-md-4 col-lg-3 col-form-label">Characteristic profile</label>
                                    <div className="col-md-2 col-lg-2 pe-2">
                                      <ComboboxField
                                        name="characteristicProfile"
                                        type="text"
                                        className="form-control "
                                        value={formInputs.characteristicProfile || ""}
                                        onChange={onInputChange}
                                      />
                                    </div>
                                    <div className="col-md-6 col-lg-7">
                                      <InputField name="characteristicProfile" type="text" className="form-control" id="characteristicProfile" value={formInputs.characteristicProfile || ""} onChange={onInputChange} />
                                    </div>
                                  </div>
                                  <Col sm={12} md={12} lg={12} className='p-2 d-flex flex-column flex-nowrap' >
                                    <h5 className="card-title" style={{ color: '#012970' }}>Dimensions/EANS</h5>
                                    <hr />
                                    <div className="row mb-3">
                                      <label for="baseUnitofMeasure" className="col-md-2 col-lg-2 col-form-label">Base Unit of Measure</label>
                                      <div className="col-md-8 col-lg-9">
                                        <InputField name="baseUnitofMeasure" type="text" className="form-control" id="baseUnitofMeasure" value={formInputs.baseUnitofMeasure || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="grossWeight" className="col-md-2 col-lg-2 col-form-label">Gross Weight</label>
                                      <div className="col-md-8 col-lg-9">
                                        <InputField name="grossWeight" type="text" className="form-control" id="grossWeight" value={formInputs.grossWeight || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="netWeight" className="col-md-2 col-lg-2 col-form-label">Net Weight</label>
                                      <div className="col-md-8 col-lg-9">
                                        <InputField name="netWeight" type="text" className="form-control" id="netWeight" value={formInputs.netWeight || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="weightUnit" className="col-md-2 col-lg-2 col-form-label">Weight Unit</label>
                                      <div className="col-md-8 col-lg-9">
                                        <InputField name="weightUnit" type="text" className="form-control" id="weightUnit" value={formInputs.weightUnit || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="TaxClassification" className="col-md-2 col-lg-2 col-form-label">Tax Classification</label>
                                      <div className="col-md-8 col-lg-9">
                                        <InputField name="TaxClassification" type="text" className="form-control" id="TaxClassification" value={formInputs.TaxClassification || ""} onChange={onInputChange} />
                                      </div>
                                    </div>
                                  </Col>
                                </Col>
                              </Row>
                            </form>
                          </div>
                        </div>
                        {/* Basic Data: Fashions */}
                        <div className="tab-pane fade profile-edit pt-3" id="basicDataFashion">
                          <form>
                            <div className="row mb-3">
                              {/* <label for="profileImage" className="col-md-4 col-lg-3 col-form-label">Profile Image</label> */}
                              <Col sm={12} md={12} lg={12} className='p-2 d-flex flex-column flex-nowrap' >
                                <h5 className="card-title" style={{ color: '#012970' }}>Fashion Attributes</h5>
                                <hr />
                                <div className="row mb-3">
                                  <label htmlFor="styleCode" className="col-md-4 col-lg-3 col-form-label">Style</label>
                                  <div className="col-md-8 col-lg-9">
                                    <div className="input-group">
                                      {/* Main input field for Fabric Content Group */}
                                      <InputField
                                        name="style"
                                        type="text"
                                        className="form-control"
                                        id="netWeight"
                                        value={formInputs.style || ""}
                                        onChange={onInputChange}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label htmlFor="fashionCollection" className="col-md-4 col-lg-3 col-form-label">Fashion Collection</label>
                                  <div className="col-md-8 col-lg-9">
                                    <div className="input-group">
                                      {/* Main input field for Fabric Content Group */}
                                      <input
                                        name="fashionCollection"
                                        type="text"
                                        className="form-control"
                                        id="fashionCollection"
                                        value={formInputs.fashionCollection || ""}
                                        onChange={onInputChange}
                                      />
                                      {/* Small input field next to the main one */}
                                      <div className="input-group-append ml-2">
                                        <input
                                          name="fashionCollection"
                                          type="text"
                                          className="form-control form-control-m ml-2"  // Small input field
                                          value={formInputs.fashionCollection || ""}
                                          onChange={onInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label htmlFor="fashionTheme" className="col-md-4 col-lg-3 col-form-label">Fashion Theme</label>
                                  <div className="col-md-8 col-lg-9">
                                    <div className="input-group">
                                      {/* Main input field for Fabric Content Group */}
                                      <input
                                        name="fashionTheme"
                                        type="text"
                                        className="form-control"
                                        id="fashionTheme"
                                        value={formInputs.fashionTheme || ""}
                                        onChange={onInputChange}
                                      />

                                      {/* Small input field next to the main one */}
                                      <div className="input-group-append ml-2">
                                        <input
                                          name="fashionTheme"
                                          type="text"
                                          className="form-control form-control-m ml-2"  // Small input field
                                          value={formInputs.fashionTheme || ""}
                                          onChange={onInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label htmlFor="seasonIndicator" className="col-md-4 col-lg-3 col-form-label">Season Indicator</label>
                                  <div className="col-md-8 col-lg-9">
                                    <div className="input-group">
                                      {/* Main input field for Fabric Content Group */}
                                      <input
                                        name="seasonIndicator"
                                        type="text"
                                        className="form-control"
                                        id="seasonIndicator"
                                        value={formInputs.seasonIndicator || ""}
                                        onChange={onInputChange}
                                      />

                                      {/* Small input field next to the main one */}
                                      <div className="input-group-append ml-2">
                                        <input
                                          name="seasonIndicator"
                                          type="text"
                                          className="form-control form-control-m ml-2"  // Small input field
                                          value={formInputs.seasonIndicator || ""}
                                          onChange={onInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label htmlFor="fabricContent" className="col-md-4 col-lg-3 col-form-label">Fabric Content</label>
                                  <div className="col-md-8 col-lg-9">
                                    <div className="input-group">
                                      {/* Main input field for Fabric Content Group */}
                                      <input
                                        name="fabricContent"
                                        type="text"
                                        className="form-control"
                                        id="fabricContent"
                                        value={formInputs.fabricContent || ""}
                                        onChange={onInputChange}
                                      />

                                      {/* Small input field next to the main one */}
                                      <div className="input-group-append ml-2">
                                        <input
                                          name="fabricContent1"
                                          type="text"
                                          className="form-control form-control-m ml-2"  // Small input field
                                          value={formInputs.fabricContent1 || ""}
                                          onChange={onInputChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Col>
                              <form>
                                <Row className=''>
                                  <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap '>
                                    <h5 className="card-title" style={{ color: '#012970' }}>Segmentation Data</h5>
                                    <hr />
                                    <div className="row mb-3">
                                      <label htmlFor="sigmantRelavant" className="col-md-4 col-lg-3 col-form-label">Segment Relevant</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="form-check">
                                          <input
                                            name="sigmantRelavant"
                                            type="checkbox"
                                            className="form-check-input"
                                            id="sigmantRelavant"
                                            checked={formInputs.sigmantRelavant || false}  // Checkbox is checked only if true
                                            onChange={onInputChange}
                                          />
                                          <label className="form-check-label" htmlFor="sigmantRelavant">
                                            Yes
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="segmentationStructure" className="col-md-4 col-lg-3 col-form-label">Segmentation Structure</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}

                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <InputField
                                              name="segmentationStructure"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.segmentationStructure || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <InputField name="segmentationStructure" type="text" className="form-control" id="category" value={formInputs.segmentationStructure || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="segmentationStrategy" className="col-md-4 col-lg-3 col-form-label">Segmentation Strategy</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <InputField
                                              name="segmentationStrategy"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.segmentationStrategy || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <InputField name="segmentationStrategy" type="text" className="form-control" id="segmentationStrategy" value={formInputs.segmentationStrategy || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                    <Col sm={12} md={12} lg={12} className='p-2 d-flex flex-column flex-nowrap' >
                                      <h5 className="card-title" style={{ color: '#012970' }}>Season AssignMent</h5>
                                      <hr />
                                      <div className="row mb-3">
                                        <label htmlFor="season" className="col-md-4 col-lg-3 col-form-label">Season</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group">
                                            {/* Main input field for Fabric Content Group */}
                                            <input
                                              name="season"
                                              type="text"
                                              className="form-control"
                                              id="season"
                                              value={formInputs.season || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label htmlFor="seasonCategory" className="col-md-4 col-lg-3 col-form-label">Season Category</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group">
                                            {/* Main input field for Fabric Content Group */}
                                            <input
                                              name="seasonCategory"
                                              type="text"
                                              className="form-control"
                                              id="seasonCategory"
                                              value={formInputs.seasonCategory || ""}
                                              onChange={onInputChange}
                                            />
                                            {/* Small input field next to the main one */}
                                            <div className="input-group-append ml-2">
                                              <input
                                                name="group1"
                                                type="text"
                                                className="form-control form-control-m ml-2"  // Small input field
                                                value={formInputs.group1 || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label htmlFor="seasonYear" className="col-md-4 col-lg-3 col-form-label">Season year</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group">
                                            {/* Main input field for Fabric Content Group */}
                                            <input
                                              name="seasonYear"
                                              type="text"
                                              className="form-control"
                                              id="seasonYear"
                                              value={formInputs.seasonYear || ""}
                                              onChange={onInputChange}
                                            />

                                            {/* Small input field next to the main one */}
                                            <div className="input-group-append ml-2">
                                              <input
                                                name="seasonYear"
                                                type="text"
                                                className="form-control form-control-m ml-2"  // Small input field
                                                value={formInputs.seasonYear || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Col>
                                  <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap' >
                                    <h5 className="card-title" style={{ color: '#012970' }}>Article Conversion ID</h5>
                                    <hr />
                                    <div className="row mb-3">
                                      <label for="articleConversionID" className="col-md-4 col-lg-3 col-form-label">Article.Conv.ID</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="articleConversionID"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.articleConversionID || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="articleConversionID" type="text" className="form-control" id="articleConversionID" value={formInputs.articleConversionID || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </form>
                            </div>
                            <Col xs={12} md={12} lg={12} className='commLeftRightPadding'>
                              <p className='errorMsg'> {errorMsg} </p>
                            </Col>
                          </form>
                        </div>
                        {/* Basic data attribute  */}
                        <div className="tab-pane fade profile-edit pt-3" id="dimension">
                          <form>
                            <div className="row mb-3">
                              <form>
                                <Row className=''>
                                  <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap '>
                                    <h5 className="card-title" style={{ color: '#012970' }}>Attribute Data 1</h5>
                                    <hr />
                                    <div className="row mb-3">
                                      <label for="segmantationStructure" className="col-md-4 col-lg-3 col-form-label">Gender</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="gender"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.gender || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="gender" type="text" className="form-control" id="category" value={formInputs.gender || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="segmantStrategy" className="col-md-4 col-lg-3 col-form-label">Sub Gender</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="subGender"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.subGender || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="subGender" type="text" className="form-control" id="subGender" value={formInputs.subGender || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label for="styleDescription" className="col-md-4 col-lg-3 col-form-label">Style Description</label>
                                        <div className="col-md-8 col-lg-9">
                                          <InputField name="styleDescription" type="text" className="form-control" id="styleDescription" value={formInputs.styleDescription || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label for="multipleMRP" className="col-md-4 col-lg-3 col-form-label">Multiple Mrp </label>
                                        <div className="col-md-8 col-lg-9">
                                          <InputField name="multipleMRP" type="text" className="form-control" id="multipleMRP" value={formInputs.multipleMRP || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label for="segmantationStructure" className="col-md-4 col-lg-3 col-form-label">Color</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group ">
                                            {/* Small input field with inside */}
                                            <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                              <InputField
                                                name="color"
                                                type="text"
                                                className="form-control pe-4"
                                                value={formInputs.color || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                            <input name="color" type="text" className="form-control" id="category" value={formInputs.color || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <Col sm={12} md={12} lg={12} className='p-2 d-flex flex-column flex-nowrap' >
                                      <h5 className="card-title" style={{ color: '#012970' }}>Attribute 3</h5>
                                      <hr />
                                      <div className="row mb-3">
                                        <label for="FIT" className="col-md-4 col-lg-3 col-form-label">Fit</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group ">
                                            {/* Small input field with inside */}
                                            <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                              <input
                                                name="FIT"
                                                type="text"
                                                className="form-control pe-4"
                                                value={formInputs.FIT || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                            <input name="FIT" type="text" className="form-control" id="FIT" value={formInputs.FIT || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="FITName" className="col-md-4 col-lg-3 col-form-label">Fit Name</label>
                                          <div className="col-md-8 col-lg-9">
                                            <div className="input-group ">
                                              {/* Small input field with inside */}
                                              <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                                <input
                                                  name="FITName"
                                                  type="text"
                                                  className="form-control pe-4"
                                                  value={formInputs.FITName || ""}
                                                  onChange={onInputChange}
                                                />
                                              </div>
                                              <input name="FITName" type="text" className="form-control" id="FITName" value={formInputs.FITName || ""} onChange={onInputChange} />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="designCode" className="col-md-4 col-lg-3 col-form-label">Design Code</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="designCode" type="text" className="form-control" id="designCode" value={formInputs.designCode || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="designType" className="col-md-4 col-lg-3 col-form-label">Design Type</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="designType" type="text" className="form-control" id="designType" value={formInputs.designType || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="collor_Neck_Pleate" className="col-md-4 col-lg-3 col-form-label">Collor/Neck/pleate</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="collor_Neck_Pleate" type="text" className="form-control" id="collor_Neck_Pleate" value={formInputs.collor_Neck_Pleate || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="sleev" className="col-md-4 col-lg-3 col-form-label">Sleev</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="sleev" type="text" className="form-control" id="sleev" value={formInputs.sleev || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="occasion" className="col-md-4 col-lg-3 col-form-label">Occasion</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="occasion" type="text" className="form-control" id="occasion" value={formInputs.occasion || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="garmentFinish" className="col-md-4 col-lg-3 col-form-label">Garment Finish</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="garmentFinish" type="text" className="form-control" id="garmentFinish" value={formInputs.garmentFinish || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="inseam" className="col-md-4 col-lg-3 col-form-label">Inseam</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="inseam" type="text" className="form-control" id="inseam" value={formInputs.inseam || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="subLabel" className="col-md-4 col-lg-3 col-form-label">Sub label</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="subLabel" type="text" className="form-control" id="subLabel" value={formInputs.subLabel || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="categoryGroup" className="col-md-4 col-lg-3 col-form-label">Category Group</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="categoryGroup" type="text" className="form-control" id="categoryGroup" value={formInputs.categoryGroup || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="subCategory" className="col-md-4 col-lg-3 col-form-label">Sub Category Group</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="subCategory" type="text" className="form-control" id="subCategory" value={formInputs.subCategory || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="categoryType" className="col-md-4 col-lg-3 col-form-label">Category type</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="categoryType" type="text" className="form-control" id="categoryType" value={formInputs.categoryType || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="selable" className="col-md-4 col-lg-3 col-form-label">Selable</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="selable" type="text" className="form-control" id="selable" value={formInputs.selable || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="returanable" className="col-md-4 col-lg-3 col-form-label">Returanable</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="returanable" type="text" className="form-control" id="returanable" value={formInputs.returanable || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="class1" className="col-md-4 col-lg-3 col-form-label">Class 1</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="class1" type="text" className="form-control" id="class1" value={formInputs.class1 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="class2" className="col-md-4 col-lg-3 col-form-label">Class 2</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="class2" type="text" className="form-control" id="class2" value={formInputs.class2 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="class3" className="col-md-4 col-lg-3 col-form-label">Class 3</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="class3" type="text" className="form-control" id="class3" value={formInputs.class3 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="class4" className="col-md-4 col-lg-3 col-form-label">Class 4</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="class4" type="text" className="form-control" id="class4" value={formInputs.class4 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="freeTextBarcode1" className="col-md-4 col-lg-3 col-form-label">Free Text -Barcode 1</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="freeTextBarcode1" type="text" className="form-control" id="freeTextBarcode1" value={formInputs.freeTextBarcode1 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="freeTextBarcode2" className="col-md-4 col-lg-3 col-form-label">Free Text -Barcode 2</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="freeTextBarcode2" type="text" className="form-control" id="freeTextBarcode2" value={formInputs.freeTextBarcode2 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="freeTextBarcode3" className="col-md-4 col-lg-3 col-form-label">Free Text -Barcode 3</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="freeTextBarcode3" type="text" className="form-control" id="freeTextBarcode3" value={formInputs.freeTextBarcode3 || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="WRAP_Count" className="col-md-4 col-lg-3 col-form-label">Wrap Count</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="WRAP_Count" type="text" className="form-control" id="WRAP_Count" value={formInputs.WRAP_Count || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="WEFT_Count" className="col-md-4 col-lg-3 col-form-label">Weaft Count</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="WEFT_Count" type="text" className="form-control" id="WEFT_Count" value={formInputs.WEFT_Count || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="endsPerInch" className="col-md-4 col-lg-3 col-form-label">Ends Per Inch</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="endsPerInch" type="text" className="form-control" id="endsPerInch" value={formInputs.endsPerInch || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                        <div className="row mb-3">
                                          <label for="picksPerInch" className="col-md-4 col-lg-3 col-form-label">Picks Per Inch</label>
                                          <div className="col-md-8 col-lg-9">
                                            <InputField name="picksPerInch" type="text" className="form-control" id="picksPerInch" value={formInputs.picksPerInch || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                  </Col>
                                  <Col sm={12} md={12} lg={6} className='p-4 d-flex flex-column flex-nowrap' >
                                    <h5 className="card-title" style={{ color: '#012970' }}>Attribute 2</h5>
                                    <hr />
                                    <div className="row mb-3">
                                      <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Fabric Finish</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="fabricFinish"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.fabricFinish || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="fabricFinish" type="text" className="form-control" id="fabricFinish" value={formInputs.fabricFinish || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Fabric Code</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="fabricCode"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.fabricCode || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="fabricCode" type="text" className="form-control" id="fabricCode" value={formInputs.fabricCode || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Fabric Type</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="fabricType"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.fabricType || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="fabricType" type="text" className="form-control" id="fabricType" value={formInputs.fabricType || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                      <div className="row mb-3">
                                        <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Weave</label>
                                        <div className="col-md-8 col-lg-9">
                                          <div className="input-group ">
                                            {/* Small input field with inside */}
                                            <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                              <input
                                                name="weave"
                                                type="text"
                                                className="form-control pe-4"
                                                value={formInputs.weave || ""}
                                                onChange={onInputChange}
                                              />
                                            </div>
                                            <input name="weave" type="text" className="form-control" id="weave" value={formInputs.weave || ""} onChange={onInputChange} />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Yarn Type</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="yarnType"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.yarnType || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="yarnType" type="text" className="form-control" id="yarnType" value={formInputs.yarnType || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row mb-3">
                                      <label for="matConv" className="col-md-4 col-lg-3 col-form-label">Leather</label>
                                      <div className="col-md-8 col-lg-9">
                                        <div className="input-group ">
                                          {/* Small input field with inside */}
                                          <div className="position-relative mr-2" style={{ maxWidth: "100px", }}>
                                            <input
                                              name="leather"
                                              type="text"
                                              className="form-control pe-4"
                                              value={formInputs.leather || ""}
                                              onChange={onInputChange}
                                            />
                                          </div>
                                          <input name="leather" type="text" className="form-control" id="leather" value={formInputs.leather || ""} onChange={onInputChange} />
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </form>
                            </div>
                            <Col xs={12} md={12} lg={12} className='commLeftRightPadding'>
                              <p className='errorMsg'> {errorMsg} </p>
                            </Col>
                          </form>
                        </div>
                        {/* Logistic dc */}
                        <div className="tab-pane profile-edit fadept-3" id="logisticsDc">
                          <form>
                            <h5 className="card-title" style={{ color: '#012970' }}>Logistics Dc</h5>
                            <div className="row mb-3">
                              <Row>
                                <Col sm={12} md={12} lg={6} className="p-0 d-flex flex-column flex-nowrap">
                                  <div className="d-flex align-items-center mb-3">
                                    <label htmlFor="storageSectID" className="col-form-label me-7">Storage Sect.ID</label>
                                    <input
                                      name="storageSectID"
                                      type="text"
                                      className="form-control"
                                      id="storageSectID"
                                      value={formInputs.storageSectID || ""}
                                      onChange={onInputChange}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col sm={12} md={12} lg={6} className="p-0 d-flex flex-column flex-nowrap">
                                  <div className="d-flex align-items-center mb-3">
                                    <label htmlFor="stockPlacement" className="col-form-label me-3">Stock placement</label>
                                    <input
                                      name="stockPlacement"
                                      type="text"
                                      className="form-control"
                                      id="stockPlacement"
                                      value={formInputs.stockPlacement || ""}
                                      onChange={onInputChange}

                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col sm={12} md={12} lg={6} className="p-0 d-flex flex-column flex-nowrap">
                                  <div className="d-flex align-items-center mb-3">
                                    <label htmlFor="stockRemoval" className="col-form-label me-3">Stock removal</label>
                                    <input
                                      name="stockRemoval"
                                      type="text"
                                      className="form-control"
                                      id="stockRemoval"
                                      value={formInputs.stockRemoval || ""}
                                      onChange={onInputChange}

                                    />
                                  </div>
                                </Col>
                              </Row>
                              <form>
                              </form>
                            </div>
                          </form>
                        </div>
                        {/* Logoistic Store Accounting */}
                        <div className="tab-pane profile-edit fadept-3" id="logisticsStore">
                          <form>
                            <div className="row mb-3">
                              <form>
                                <div className="row mb-3">
                                  <label for="futurePlannedPrice1" className="col-md-4 col-lg-3 col-form-label">Future Planned Price 1</label>
                                  <div className="col-md-8 col-lg-9">
                                    <InputField name="futurePlannedPrice1" type="text" className="form-control" id="futurePlannedPrice1" value={formInputs.futurePlannedPrice1 || ""} onChange={onInputChange} />
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label for="futurePlannedPriceIsValid" className="col-md-4 col-lg-3 col-form-label">Date from Which Future Planned Price 1 Is Valid</label>
                                  <div className="col-md-8 col-lg-9">
                                    <InputField name="futurePlannedPriceIsValid" type="text" className="form-control" id="futurePlannedPriceIsValid" value={formInputs.futurePlannedPriceIsValid || ""} onChange={onInputChange} />
                                  </div>
                                </div>
                                <div className="row mb-3">
                                  <label for="commodityCode" className="col-md-4 col-lg-3 col-form-label">Control code for consumption taxes in foreign trade</label>
                                  <div className="col-md-8 col-lg-9">
                                    <InputField name="commodityCode" type="text" className="form-control" id="commodityCode" value={formInputs.commodityCode || ""} onChange={onInputChange} />
                                  </div>
                                </div>
                              </form>
                            </div>
                          </form>
                        </div>
                        {/* Logistic DC fashion */}
                        {/* Logistic dc */}
                        <div className="tab-pane profile-edit fadept-3" id="logisticsDcFashion">
                          <form>
                            {/* <h5 className="card-title" style={{ color: '#012970' }}>Logistics Dc</h5> */}
                            <Col sm={12} md={12} lg={12} className='p-4'>
                              <div className="row mb-3">
                                <label for="indicatorInventory" className="col-md-2 col-lg-2 col-form-label">Indicator: Season Active in Inventory Management</label>
                                <div className="col-md-4 col-lg-4">
                                  <input name="indicatorInventory" type="text" className="form-control" id="indicatorInventory" value={formInputs.indicatorInventory || ""} onChange={onInputChange} />
                                </div>
                              </div>
                            </Col>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Col>
      </Row>
      <Col lg={2} className="d-flex justify-content-center mt-2 mx-auto">
        <button
          className="btnTable"
          disabled={disabled}
          onClick={handleSave}
        >
          Save
        </button>
      </Col>

    </main>
  );
};

export default ArticleCreation;
